<template>
    <div>
        <van-row class="title-row" type="flex" justify="space-between">
            <van-col span="10">
                <i class="icon-box"></i>
                <span class="section-title">单挑专家TOP</span>
            </van-col>
            <van-col class="col-right" span="14">
                <span :class="{ active: lotteryId === 1 }" @click="changeLottery(1)">福彩3D</span>
                <span :class="{ active: lotteryId === 2 }" @click="changeLottery(2)">排列三</span>
            </van-col>
        </van-row>
        <div style="max-height: 204px; overflow: hidden;">
            <transition name="van-slide-left">
                <van-grid v-if="lotteryId == 1" 
                    :border="false" 
                    :column-num="5" 
                    >
                    <van-grid-item class="my-grid-item" v-for="item in mavinTopList" :key="item.id"
                        @click="toMavinPage(item.id)">
                        <van-image width="40" height="40" class="head-img" round lazy-load fit="cover"
                            :src="'/img/headImg/' + item.headImg" />
                        <div class="title van-ellipsis" v-text="item.nickName"></div>
                        <div class="money van-ellipsis">
                            {{ item.sumWinMoney | moneyFilter }}
                            <span class="unit">万</span>
                        </div>
                    </van-grid-item>
                    <van-grid-item class="my-grid-item" @click="moreMavin(1)">
                        <van-icon name="more" size="40" color="#EFEDEE" />
                        <div class="title van-ellipsis">更多排名</div>
                    </van-grid-item>
                </van-grid>
            </transition>
            <transition name="van-slide-left">
                <van-grid v-if="lotteryId == 2" :border="false" :column-num="5">
                    <van-grid-item class="my-grid-item" v-for="item in mavinTopList2" :key="item.id"
                        @click="toMavinPage(item.id)">
                        <van-image width="36" height="36" class="head-img" round lazy-load fit="cover"
                            :src="'/img/headImg/' + item.headImg" />
                        <div class="title van-ellipsis" v-text="item.nickName"></div>
                        <div class="money van-ellipsis">
                            {{ item.sumWinMoney | moneyFilter }}
                            <span class="unit">万</span>
                        </div>
                    </van-grid-item>
                    <van-grid-item class="my-grid-item" @click="moreMavin(2)">
                        <van-icon name="more" size="36" color="#EFEDEE" />
                        <div class="title van-ellipsis">更多排名</div>
                    </van-grid-item>
                </van-grid>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MavinListTop',
    data() {
        return {
            lotteryId: 1,
        }
    },
    props: ['mavinTopList', 'mavinTopList2', 'areaId', 'LotId'],
    watch: {
        LotId: {
            handler(newVal) {
                this.lotteryId = newVal
            },
            immediate: true // 组件创建时立即执行
        }
    },
    filters: {
        moneyFilter(v) {
            return Math.round((v / 10000) * 100) / 100
        },
    },
    methods: {
        // 切换彩种
        changeLottery(lotteryId) {
            this.lotteryId = lotteryId
            // this.$emit('changeLottery', lotteryId, this.areaId)
        },

        // 查看专家
        toMavinPage(id) {
            this.$router.push({
                path: '/mavin',
                query: { id }
            })
        },

        // 更多专家
        moreMavin(lotteryId) {
            this.$router.push({
                path: '/charts',
                query: {
                    lotteryId
                }
            })
        },
    }
}
</script>

<style scoped>
/* 专家样式 */
.title-row {
    line-height: 20px;
}

.title-row .icon-box {
    display: inline-block;
    height: 20px;
    width: 8px;
    border-radius: 3px 0 0 3px;
    background-color: #F54B4A;
}

.title-row span.section-title {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    position: absolute;
    margin-left: 3px;
    font-size: 18px;
    font-weight: 700;
    color: #202020;
}

.title-row .col-right {
    text-align: right;
}

.title-row .col-right span {
    margin-right: 10px;
    font-size: 14px;
    font-weight: 500;

    display: inline-block;
    margin-top: -5px;
    padding-bottom: 5px;
}

.title-row .col-right span.active {
    font-weight: bold;
    color: #F54B4A;
    border-bottom: 2px solid #F54B4A;
}

.van-grid {
    margin-left: 2px;
    margin-right: 2px;
}

.my-grid-item ::v-deep .van-grid-item__content {
    padding-top: 16px;
    padding-bottom: 0;
    display: flex;
    justify-content: flex-start;
}

.title {
    display: block;
    font-size: 13px;
    color: #202020;
    line-height: 26px;
    max-width: 52px;
    text-align: center;
}

.head-img {
    width: 75%;
}

.money {
    width: 85%;
    border-radius: 3px;
    /* background-color: #F54B4A;
    color: #fff; */
    background-color: #FDE3E2 ;
    color: #676767;
    text-align: center;
    line-height: 20px;
    height: 20px;
    font-size: 13px;
    font-weight: 600;
    /* display: flex;
    justify-content: flex-end; */
    position: relative;
    padding-right: 15px;
}

.money .unit {
    border-radius: 0 3px 3px 0;
    background-color: #fff;
    color: #F54B4A;
    /* margin: 2px; */
    display: block;
    height: 14px;
    line-height: 14px;
    padding: 1px 2px;
    font-size: 10px;

    position: absolute;
    top: 2px;
    right: 2px;

}

/* ====================宫格边框======================= */
.responsive-grid {
  border: none !important;
}

.responsive-grid ::v-deep .van-grid-item {
  border-right: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
}

/* 使用 CSS 变量控制列数 */
.responsive-grid ::v-deep .van-grid-item:nth-child(var(--cols)n) {
  border-right: none;
}

.responsive-grid ::v-deep .van-grid-item:nth-last-child(-n+var(--cols)) {
  border-bottom: none;
}
</style>